
export default {
  isochronesDetails: {
    'polygons': 'Polígonos',
    'center': 'Centro',
    'reachCenters': 'Centros de alcance',
    'toggleVisibility': 'Alternar visibilidad',
    'opacity': 'Opacidad'
  }
}
